/* eslint-disable @typescript-eslint/no-magic-numbers */
export const MOTION_EASE_STANDARD = [0.22, 1, 0.36, 1] as const;

export const UI_TRANSITION_SECONDS = {
  page: 0.28,
  modalEntry: 0.28,
  profileCompaniesList: 0.22,
  profileCompaniesListDelay: 0.08,
  drawerContentFadeIn: 0.4,
  fadeSwitchEnter: 0.28,
  fadeSwitchExit: 0.28,
  dashboardCardAppear: 0.4,
} as const;

export const DRAWER_MOTION_SECONDS = {
  enter: 0.65,
  rideEnter: 0.45,
  enterDelay: 0.1,
  enterOpacity: 0,
  settingsContentEnter: 0.85,
  settingsContentEnterOffsetPx: 16,
} as const;

export const SESSION_GATE_LOADER_MS = {
  overlayFadeMs: 180,
  hideDebounceMs: 350,
  settleDelayMs: 400,
} as const;

export const ANIMATED_PAGE_MOTION = {
  ease: "easeOut",
  exitEase: "easeIn",
  exitDurationSeconds: UI_TRANSITION_SECONDS.page,
  initialOpacity: 0,
} as const;

export const ANIMATED_FADE_SWITCH_MOTION = {
  enterDurationSeconds: UI_TRANSITION_SECONDS.fadeSwitchEnter,
  exitDurationSeconds: UI_TRANSITION_SECONDS.fadeSwitchExit,
} as const;

export const DEFAULT_EDIT_PAGE_TRANSITION_DURATION = UI_TRANSITION_SECONDS.page;
export const RIDE_EDIT_PAGE_TRANSITION_DURATION = UI_TRANSITION_SECONDS.page;
export const RIDE_ADD_PAGE_TRANSITION_DURATION = UI_TRANSITION_SECONDS.page;

export const DRAWER_MOTION_ENTER_DURATION_S = DRAWER_MOTION_SECONDS.enter;
export const DRAWER_MOTION_RIDE_ENTER_DURATION_S =
  DRAWER_MOTION_SECONDS.rideEnter;
export const DRAWER_MOTION_ENTER_DELAY_S = DRAWER_MOTION_SECONDS.enterDelay;
export const DRAWER_MOTION_ENTER_OPACITY = DRAWER_MOTION_SECONDS.enterOpacity;
export const DRAWER_CONTENT_FADE_IN_DURATION_S =
  UI_TRANSITION_SECONDS.drawerContentFadeIn;
export const DRAWER_SETTINGS_CONTENT_ENTER_DURATION_S =
  DRAWER_MOTION_SECONDS.settingsContentEnter;
export const DRAWER_SETTINGS_CONTENT_ENTER_OFFSET_PX =
  DRAWER_MOTION_SECONDS.settingsContentEnterOffsetPx;
